import React from 'react';
import style from './style.module.scss';

const Divider: React.FC = () => {
    return <div className={style.divider}></div>;
};

export default Divider;
